import { toast } from "sonner";

/**
 * Copy text to clipboard with graceful fallback. Never throws / never leaves an
 * unhandled promise rejection (which would trigger the dev error overlay).
 */
export const copyToClipboard = async (text, successMsg = "Copied to clipboard", description) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    toast.success(successMsg, description ? { description } : undefined);
    return true;
  } catch {
    toast.message("Copy this link", { description: text });
    return false;
  }
};
